module.exports = __webpack_public_path__ + "static/media/PATS_2-480w.8564d1ab.png";